import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

import NeuriteGrid from '../../components/neurite_grid';

//actions:
import {
    getZonasCentro, modifyZonaCentro, addZonaCentro, removeZonaCentro
} from '../../actions/zonas_centro_actions';
import {
    openDialog, hideDialog, setSaveState
} from '../../actions';



const styles = theme => ({
    title: {
        margin: '5px 10px',
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class CentroZonas extends React.Component {

    modifyZonaCentro = (zona) => {
        this.props.setSaveState(true);
        this.props.modifyZonaCentro(zona);
    };

    addZonaCentro = (zona) => {
        this.props.setSaveState(true);
        this.props.addZonaCentro(zona);
    };

    messageError = (error) => {

        this.props.openDialog('SimpleMessage', {
            message: error
        }, uuidv4(), false, 'sm');

    };

    checkZona = (zona) => {

        if (this.props.zonasCentro.find(c => (c.descr === zona.descr) && (c.id !== zona.id))) {
            this.messageError(`Ya existe una zona ${zona.descr} en este centro`);
            return false;
        } else if (!zona.descr.trim().length) {
            this.props.openDialog('SimpleMessage', { message: `Por favor, introduzca un nombre de zona` }, uuidv4(), false, 'sm');
            return false;
        }
        else return true;

    };


    editZona = (zona) => {
        this.props.openDialog('EditZonaCentro', {
            zonaCentro: zona,
            tiposZona: this.props.tiposZona,
            okHandler: this.modifyZonaCentro,
            checkZona: this.checkZona,
            centroid: this.props.centroid
        }, uuidv4());
    };

    newZona = () => {

        this.props.openDialog('EditZonaCentro', {
            zonaCentro: {},
            tiposZona: this.props.tiposZona,
            okHandler: this.addZonaCentro,
            checkZona: this.checkZona,
            centroid: this.props.centroid
        }, uuidv4());

    };

    removeZona = zona => {
        this.props.setSaveState(true);
        this.props.removeZonaCentro(zona);
    };

    componentDidMount() {

        this.props.getZonasCentro(this.props.centroid);

    };

    render() {

        const { classes } = this.props;

        return (
            <div >
                <Typography variant="h6" className={classes.title} color={'primary'}>Zonas</Typography>
                {this.props.zonasCentro && !this.props.isLoading ?
                    <NeuriteGrid
                    id="c_z"
                        columns={[
                            { key: 'descr', name: 'Descripción', editable: false, dragable: false, width: 100, },
                            { key: 'tipoZona', name: 'Tipo de zona', editable: false, dragable: false, width: 100, },
                            { key: 'activo', name: 'Activo', type: 'bool', editable: false, dragable: false, width: 55, },
                            {
                                key: 'launch', name: '', editable: false, dragable: false, type: 'launch', handleLaunchClick: (row) => {
                                    this.props.openDialog('ListaMovimientos', {
                                        zona_id: row.id,
                                    }, uuidv4(), false, 'sm');
                                }
                            },
                        ]}
                        rows={this.props.zonasCentro.filter(c => c.centroId === this.props.centroid)}
                        buttonEdit={true}
                        buttonDelete={true}
                        buttonNew={true}
                        onNewRowClick={this.newZona}
                        onEditClick={this.editZona}
                        onDeleteClick={this.removeZona}
                        height={200}
                    />
                    : <div className={classes.spinnerContainer}> <CircularProgress className={classes.spinner} color="primary" /> </div>}
            </div>
        );

    };

};

CentroZonas.propTypes = {
    //state
    zonasCentro: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    tiposZona: PropTypes.array.isRequired,
    //dispatch
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    getZonasCentro: PropTypes.func.isRequired,
    modifyZonaCentro: PropTypes.func.isRequired,
    addZonaCentro: PropTypes.func.isRequired,
    removeZonaCentro: PropTypes.func.isRequired,
    //parameters
    centroid: PropTypes.number.isRequired,
};

function mapStateToProps(state) {
    return {
        zonasCentro: state.zonasCentro.zonas,
        isLoading: state.zonasCentro.isLoading,
        tiposZona: state.tiposZona.tiposzona,
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDialog: openDialog,
        hideDialog: hideDialog,
        getZonasCentro: getZonasCentro,
        modifyZonaCentro: modifyZonaCentro,
        addZonaCentro: addZonaCentro,
        removeZonaCentro: removeZonaCentro,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(CentroZonas));